import axios from 'axios';
import { getToken } from './auth';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api/mail' });

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getCategories = () => api.get('/categories').then(r => r.data);
export const getFolders = () => api.get('/folders').then(r => r.data);
export const getChildFolders = (folderId) => api.get(`/folders/${folderId}/children`).then(r => r.data);

export const getMessages = (folderId, { skip = 0, top = 25, search = '', filter = '' } = {}) =>
  api.get(`/folders/${folderId}/messages`, { params: { skip, top, search, filter } }).then(r => r.data);

export const getAllMessages = (folderId, months = 12) =>
  api.get(`/folders/${folderId}/all`, { params: { months } }).then(r => r.data);

export const getMessage = id => api.get(`/messages/${id}`).then(r => r.data);
export const getConversation = conversationId => api.get(`/conversations/${conversationId}`).then(r => r.data);
export const getAttachments = id => api.get(`/messages/${id}/attachments`).then(r => r.data);

export const getPins = () => api.get('/pins').then(r => r.data);
export const togglePin = (id) => api.post(`/pins/${id}/toggle`).then(r => r.data);

export const patchMessage = (id, body) => api.patch(`/messages/${id}`, body).then(r => r.data);
export const flagMessage = (id, flagStatus) => patchMessage(id, { flag: { flagStatus } });
export const markRead = (id, isRead) => patchMessage(id, { isRead });
export const categorizeMessage = (id, categories) => patchMessage(id, { categories });

export const sendEmail = payload => api.post('/send', payload).then(r => r.data);
export const saveDraft = payload => api.post('/drafts', payload).then(r => r.data);
export const replyEmail = (id, body, replyAll = false) =>
  api.post(`/messages/${id}/reply`, { body, replyAll }).then(r => r.data);
export const forwardEmail = (id, to, comment) =>
  api.post(`/messages/${id}/forward`, { to, comment }).then(r => r.data);
// Both return { id } of the message in its new location (Exchange can reassign IDs on move)
export const moveMessage = (id, folderId) =>
  api.post(`/messages/${id}/move`, { folderId }).then(r => r.data);
export const deleteMessage = id =>
  api.delete(`/messages/${id}`).then(r => r.data); // returns { ok, newId }
